import CloseIcon from "@mui/icons-material/Close";
import { Input } from "../../../../../common/Input";
import { useEffect, useState } from "react";
import { useEnumsApi } from "../../../../hooks/useEnumsApi";

export function EditSalaryAdvanceTypeModal({ isOpen, onClose, onUpdate, request }) {
  // 1. Get the dynamic list from your hook
  const { salaryAdvanceTypes, loading: loadingEnums } = useEnumsApi();
  
  // 2. Set state as a number (since the Enum value is an integer)
  const [advanceType, setAdvanceType] = useState(0);

  useEffect(() => {
    if (isOpen && request) {
      // Sync with existing value from request, or default to 0 (None)
      setAdvanceType(request.salaryAdvanceType || 0);
    }
  }, [isOpen, request]);

  if (!isOpen || !request) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto"
    >
      <div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] xl:w-[40%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">

        {/* Header */}
        <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 flex items-center space-x-2">
            <span className="text-xl text-gray-600">Edit Salary Advance Type</span>
          </h2>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 transition-colors p-1 bg-transparent border-none cursor-pointer"
          >
            <CloseIcon fontSize="medium" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto flex-grow space-y-4">
          <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm pb-6 pt-2">
            <div className="py-1 border-b border-gray-300 mb-4">
              <h3 className="font-medium text-gray-700 uppercase text-xs tracking-widest">Classification Details</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
              <Input
                label="Reference Number"
                value={request.referenceNumber}
                isViewOnly={true}
              />

              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Salary Advance Type
                </label>
                <select
                  disabled={loadingEnums}
                  value={advanceType}
                  // 3. IMPORTANT: Convert the string value from the event to a Number
                  onChange={(e) => setAdvanceType(Number(e.target.value))}
                  className="w-full border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 text-gray-700"
                >
                  {/* 4. Map the Enum list from the backend */}
                  {salaryAdvanceTypes?.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-2 justify-end p-5 border-t border-gray-200 bg-white rounded-b-lg shadow-sm">
          <button
            onClick={onClose}
            className="bg-gray-400 hover:bg-gray-500 text-white px-8 py-2 rounded border-none cursor-pointer transition-colors font-medium"
          >
            Close
          </button>
          <button
            onClick={() => onUpdate(advanceType)}
            className="bg-blue-400 hover:bg-blue-500 text-white px-8 py-2 rounded border-none cursor-pointer transition-colors font-medium"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}